<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('tasks')" :directory="$t('tasks')" :icon="'sidebar'"/>
        <div class="card card-with-shadow border-0">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_tasks') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                <form ref="form" data-url="/form/validate-fields" class="mb-sm-0" :class="{'loading-opacity': preloader}">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('users') }}</label>
                                <app-input type="search-select"
                                    :placeholder="$t('select_user')"
                                    :list="list"
                                    :required="true"
                                    v-model="inputs.select_user"/>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label >{{ $t('task_category') }}</label>
                                <app-input type="search-select"
                                    :placeholder="$t('select_task_category')"
                                    :list="list"
                                    :required="true"
                                    v-model="inputs.select_task_category"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('title') }}</label>
                                <app-input type="text"
                                    :required="true"
                                    v-model="inputs.title"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('description') }}</label>
                                <app-input type="text-editor"
                                    :required="true"
                                    id="text-editor-id"
                                    :label="$t('message_placeholder')" v-model="inputs.description"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <app-input type="single-checkbox"
                                    :list-value-field="$t('task_dependent')"
                                    v-model="checked_task_dependent"/>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="checked_task_dependent">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('dependent_task') }}</label>
                                <app-input type="search-select"
                                    :placeholder="$t('select_dependent_task')"
                                    :list="list"
                                    :required="true"
                                    v-model="inputs.dependent_task"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('tags') }}</label>
                                <app-input type="text"
                                       :required="true"
                                       v-model="inputs.tags"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('start_date') }}</label>
                                <app-input type="date"
                                    :required="true"
                                    v-model="inputs.start_date"
                                    :placeholder="$t('select_valid_date')"/>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label >{{ $t('end_date') }}</label>
                                <app-input type="date"
                                    :required="true"
                                    v-model="inputs.end_date"
                                    :placeholder="$t('select_valid_date')"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <app-input type="single-checkbox"
                                    :list-value-field="$t('repeat')"
                                    v-model="checked_repeat"/>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="align-items:end;" v-if="checked_repeat">
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('repeat_every') }}</label>
                                <app-input type="number"
                                    v-model="inputs.repeat_every"/>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="form-group">
                                <label></label>
                                <app-input type="select"
                                    :list="duraton"
                                    :required="true"
                                    v-model="inputs.select_duraton"/>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('cycles') }}</label>
                                <app-input type="number"
                                    v-model="inputs.cycles"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <label>{{ $t('priority') }}</label>
                                <app-input type="radio"
                                    :required="true"
                                    :list="list"
                                    v-model="inputs.priority"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group">
                                <app-input type="dropzone"
                                    :required="true"
                                   v-model="dropzone_files"/>
                                <small class="text-muted font-italic">
                                    {{ $t('recommended_dropzone_file_validation') }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submitData">
                            {{ $t('submit') }}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import AppLibrary from "../../../../Helpers/AppLibrary";

    export default {
        name: "TaskUpdate",
        extends: AppLibrary,
        mixins: [FormMixin],
        data() {
            return {
                checked_task_dependent: false,
                checked_repeat: false,
                preloader: false,
                inputs: {
                    radio: 'High',
                    priority: 'High',
                    checkbox: ''
                },
                list: [
                    {
                        id: 'High',
                        value: 'High'
                    },
                    {
                        id: 'Medium',
                        value: 'Medium'
                    },
                    {
                        id: 'Low',
                        value: 'Low'
                    },
                ],
                duraton: [
                   {id: '', value: "Choose One",},
                    {id: 'Day', value: "Day",},
                    {id: 'Week', value: "Weeks",},
                    {id: 'Month', value: "Month",},
                    {id: 'Year', value: "Year",},
                ],
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submitData() {
                if (this.inputs.date) this.inputs.date = this.getDateFormatForBackend(this.inputs.date);

                this.save(this.inputs);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.inputs = {};
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            }
        }

    }
</script>
